import { CONTACT_EMAIL } from '@/lib/site'

/** Footer for the umbrella platform brand. */
export default function UmbrellaFooter() {
  return (
    <footer className="border-t border-slate-200 bg-slate-50">
      <div className="mx-auto max-w-7xl px-6 py-14">
        <div className="grid gap-10 md:grid-cols-[1.4fr_1fr_1fr_1fr]">
          <div>
            <div className="flex items-center gap-2.5">
              <img
                src="/scamdefense-logo.png"
                alt="ScamDefense"
                className="h-9 w-9"
                width={36}
                height={36}
              />
              <span className="text-lg font-semibold tracking-tight text-slate-900">
                ScamDefense
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-slate-600">
              Practical scam prevention education, tools, and reporting guidance
              for public agencies, credit unions, and community partners.
            </p>
          </div>

          <FooterCol
            title="Solutions"
            links={[
              { label: 'For State Agencies', href: '/solutions/state-agencies' },
              { label: 'For Banks & Credit Unions', href: '/solutions/financial-institutions' },
              { label: 'For Wealth Advisors & RIAs', href: '/solutions/wealth-advisors' },
              { label: 'For Community Partners', href: '/solutions/community-partners' },
            ]}
          />
          <FooterCol
            title="Platform"
            links={[
              { label: 'Platform overview', href: '/platform' },
              { label: 'How it works', href: '/how-it-works' },
            ]}
          />
          <FooterCol
            title="Company"
            links={[
              { label: 'Our mission', href: '/about' },
              { label: 'Contact', href: '/contact' },
            ]}
          />
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-slate-200 pt-6 text-xs text-slate-600 sm:flex-row sm:items-center sm:justify-between">
          <p>
            &copy; {new Date().getFullYear()} ScamDefense. Educational content. Not legal or financial advice.
          </p>
          <div className="flex flex-wrap items-center gap-4">
            <a href="/privacy" className="hover:text-slate-900">Privacy</a>
            <a href="/terms" className="hover:text-slate-900">Terms</a>
            <a href={`mailto:${CONTACT_EMAIL}`} className="hover:text-slate-900">
              {CONTACT_EMAIL}
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}

function FooterCol({
  title,
  links,
}: {
  title: string
  links: { label: string; href: string; external?: boolean }[]
}) {
  return (
    <div>
      <p className="text-sm font-semibold text-slate-900">{title}</p>
      <ul className="mt-4 space-y-2.5 text-sm">
        {links.map(l => (
          <li key={l.label}>
            <a
              href={l.href}
              {...(l.external ? { target: '_blank', rel: 'noreferrer' } : {})}
              className="text-slate-600 transition hover:text-slate-900"
            >
              {l.label}
            </a>
          </li>
        ))}
      </ul>
    </div>
  )
}
